
import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { FaShareAlt, FaCheckCircle } from "react-icons/fa";
import styles from "../css/NewsBox.module.css";
import { useTranslate } from "../helpers/TranslateContext";
 
export default function NewsBox() {
 
  const { t, lang } = useTranslate();
 
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [readItems, setReadItems] = useState({});
  const containerRef = useRef(null);
 
  const [latestNewsText, setLatestNewsText] = useState("Latest News");
  const [recentlyReadText, setRecentlyReadText] = useState("Recently Read");
  const [readMoreText, setReadMoreText] = useState("Read more →");
  const [noMoreNewsText, setNoMoreNewsText] = useState("No more news");
  const [loadingText, setLoadingText] = useState("Loading news…");
  const [noNewsText, setNoNewsText] = useState("No news to display.");
 
  // translate UI labels
  useEffect(() => {
    async function translateUI() {
      setLatestNewsText(await t("Latest News"));
      setRecentlyReadText(await t("Recently Read"));
      setReadMoreText(await t("Read more →"));
      setNoMoreNewsText(await t("No more news"));
      setLoadingText(await t("Loading news…"));
      setNoNewsText(await t("No news to display."));
    }
    translateUI();
  }, [lang]);
 
  // Load “read” status from localStorage
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("readItems") || "{}");
    setReadItems(stored);
  }, []);
 
 
 
  // Fetch news items
  useEffect(() => {
 
const isValidArticle = async (url) => {
  if (!url) return false;
 
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
 
    await fetch(url, {
      method: "HEAD",
      mode: "no-cors",
      signal: controller.signal
    });
 
    clearTimeout(timeout);
    return true;
  } catch {
    return false;
  }
};
 
 
    async function fetchNews() {
      setLoading(true);
 
      try {
        const res = await fetch("https://fetchrss.visiontrek.io/api/items");
        const data = await res.json();
 

 
const processed = await Promise.all(
  data.map(async (item) => {
    const link = item.canonical?.[0]?.href;
 
    // ❌ skip if link invalid
    const valid = await isValidArticle(link);
    if (!valid) return null;
 
    const src =
      item.enclosure?.[1]?.href ||
      item.enclosure?.[0]?.href ||
      ((item.summary || "")
        .replace(/<a[^>]+><\/a>/gi, "")
        .match(/<img[^>]+src=["']([^"']+)["']/i) || [])[1] ||
      "";
 
    const cleanSummary = (item.summary || "")
      .replace(/<[^>]+>/g, "")
      .replace(/\s+/g, " ")
      .trim();
 
    let translatedTitle = item.title || "";
    let translatedSummary = cleanSummary || "";
 
    if (lang !== "en") {
      translatedTitle = await t(item.title || "");
      translatedSummary = await t(cleanSummary.slice(0, 120));
    }
 
    return {
      ...item,
      translatedTitle,
      translatedSummary
    };
  })
);
 
setItems(processed.filter(Boolean));
 
        setItems(processed.filter(Boolean));
 
      } catch (err) {
        console.error(err);
        toast.error("Failed to load news feed");
      } finally {
        setLoading(false);
      }
    }
 
    fetchNews();
 
  }, [lang]);
 
  // Mark items “read” after 10s in view
  useEffect(() => {
    if (!items.length) return;
 
    const timers = {};
 
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
 
          const id = entry.target.dataset.id;
          if (!id) return;
 
          if (entry.isIntersecting && !timers[id]) {
 
            timers[id] = setTimeout(() => {
 
              setReadItems((prev) => {
                if (prev[id]) return prev;
 
                const next = { ...prev, [id]: true };
                localStorage.setItem("readItems", JSON.stringify(next));
                return next;
              });
 
            }, 10000);
 
          } else if (!entry.isIntersecting && timers[id]) {
 
            clearTimeout(timers[id]);
            delete timers[id];
 
          }
        });
      },
      { root: containerRef.current, threshold: 0.6 }
    );
 
    containerRef.current
      .querySelectorAll(".card[data-id]")
      .forEach((c) => observer.observe(c));
 
    return () => {
      observer.disconnect();
      Object.values(timers).forEach(clearTimeout);
    };
 
  }, [items]);
 
  const handleShare = (id) => {
    const url = `${window.location.origin}${window.location.pathname}?id=${id}`;
 
    navigator.clipboard
      .writeText(url)
      .then(() => toast.success("🔗 Link copied!"))
      .catch(() => toast.error("❌ Copy failed"));
  };
 
  if (loading) return <div className={styles.loading}>{loadingText}</div>;
  if (!items.length) return <div className={styles.loading}>{noNewsText}</div>;
      console.log('news clg')
 
  return (
    <div className={styles.newsBox}>
 
      <h2 className={styles.title}>{latestNewsText}</h2>
      <div
        className={styles.feedContainer}
        ref={containerRef}
        onScroll={() => {}}
      >
 
        {items.map((item) => {
 
          const imageUrl =
            item.enclosure?.[1]?.href ||
            item.enclosure?.[0]?.href ||
            "";
 
          const read = !!readItems[item.id];
 
          return (
 
            <a
              key={item.id}
              href={item.canonical?.[0]?.href || "#"}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className={styles.card}
              data-id={item.id}
              style={{ scrollMarginTop: "80px" }}
            >
 
              {/* {imageUrl && (
                <img className={styles.cardImage} src={imageUrl} alt="" />
              )} */}
 
{imageUrl && (
  <img
    className={styles.cardImage}
    src={imageUrl}
    alt=""
      onError={(e) => {
      e.target.style.display = "none";
    }}
  />
)}
 
              <div className={styles.cardContent}>
 
                <h2 className={styles.cardTitle}>
                  {(item.translatedTitle?.slice(0, 50) || "").replace(/&pound;/gi, "$")}...
                </h2>
 
                <div className={styles.cardMeta}>
                  {new Date(item.publishedAt).toLocaleString()}
                  {item.author ? ` • ${item.author}` : ""}
                </div>
 
                <div className={styles.cardSummary}>
 
                  <div className="summary-text">
                    {item.translatedSummary?.slice(0, 70)}...
                  </div>
 
                  {read && (
                    <div className={styles.readSection}>
                      <FaCheckCircle
                        className={`${styles.readIcon} ${styles.read}`}
                      />
                      <span className={styles.readLabel}>{recentlyReadText}</span>
                    </div>
                  )}
 
                  <a
                    className={styles.cardLink}
                    href={item.canonical?.[0]?.href || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginTop: "10px" }}
                  >
                    {readMoreText}
                  </a>
 
                </div>
 
              </div>
 
            </a>
 
          );
        })}
 
        <div className={styles.endCard}>
          <div className="card-content">
            <h2>{noMoreNewsText}</h2>
          </div>
        </div>
 
      </div>
    </div>
  );
}